export default {
  setSetting(state, data) {
    state.setting = data || [];
  },
  setBooths(state, data) {
    state.booths = data || [];
  },
  setStoreOptions(state, data) {
    state.storeOptions = data || [];
  },
  setBranchUserPersons(state, data) {
    state.branchUserPersons = data || [];
  },
  setStores(state, data) {
    state.stores = data || [];
  },
  // لیست صفحه غرفه‌ها (جدا از دراپ‌داون booths)
  setBoothList(state, data) {
    state.boothList = data || [];
  },
  setPreOrders(state, data) {
    state.preOrders = data || [];
  },
  setPreOrderById(state, data) {
    state.preOrderById = data;
  },
  setShopSaleFactors(state, data) {
    state.shopSaleFactors = data || [];
  },
  setUserStores(state, data) {
    state.userStores = data || [];
  },
  setSalePanelGroups(state, data) {
    state.salePanelGroups = data || [];
  },
  setOrderSettlementTypes(state, data) {
    state.orderSettlementTypes = data || [];
  },
  setActivePosTerminals(state, data) {
    state.activePosTerminals = data || [];
  },
  // { printKey, link }؛ print2 لینک را باز می‌کند
  setPrintLink(state, data) {
    state.printLink = data;
  },
  setActiveBenefitCards(state, data) {
    state.activeBenefitCards = data || [];
  },
};
